import React, { useState } from 'react'
import { Mutation } from 'react-apollo'
import { Link } from 'react-router-dom'
import {
  Button, H4, InputWithLabel, Icon, Label, Div,
} from 'konsys-ui'
import { message } from 'antd'
import validator from 'validator'
import { theme } from '../../styles/_variables'
import { isEveryIndex } from '../../utils/util-services'
import history from '../../history'
import { REQ_RESET_PASSWORD_TOKEN, RESET_PASSWORD } from '../../constants/graphql/mutation'
import {
  Wrapper, LoginWrapper, LoginBox,
} from './styled'
import Background from '../../images/login/login-background.jpg'
import Cover from '../../images/login/overlay.png'

const { color } = theme

const ForgotPasswordSection = () => {
  const [email, setEmail] = useState('')

  return (
    <div>
    <Wrapper bg={Background}></Wrapper>
      <LoginWrapper>
        <LoginBox>
          <Link to='/login'>
            <Button
              ghost
              color={color.coolGrey}
              icon='far fa-arrow-left'
              onlyIcon
              style={{ position: 'absolute', top: 40, left: 40 }}
            />
          </Link>
          <H4 color={color.paleGrey}>Forget Password</H4>
          <InputWithLabel
            width='70%'
            input={{
              // ghost: true,
              placeholder: 'username@gmail.com',
              prefix: <Icon className='prefix' icon='far fa-user' />,
              color: color.coolGrey,
              onChange: e => setEmail(e.target.value),
            }}
            title={{
              text: 'email',
              color: color.paleGrey,
            }}
            margin='16px 0 32px 0'
          />
          <Mutation
            mutation={REQ_RESET_PASSWORD_TOKEN}
          >
          {(doRequestToken, { loading }) => (
            <Button
              ghost
              inverse
              text='Request new password'
              loading={loading}
              disabled={!validator.isEmail(email)}
              onClick={() => doRequestToken({
                variables: { email },
              }).then((resp) => {
                if (!resp.loading && resp.data.forgotPassword.success) {
                  message.success(resp.data.forgotPassword.message)
                  setTimeout(() => {
                    history.push('/login')
                  }, 3000)
                  // history.push('/')
                } else message.error(resp.data.forgotPassword.message)
              })}
            />
          )}
          </Mutation>
        </LoginBox>
      </LoginWrapper>
    </div>
  )
}

const ResetSection = (props) => {
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')

  const validatePassword = password.length >= 8 ? 'success' : password.length > 0 && 'error'
  const validateConfirmPassword = passwordConfirm.length > 0 && passwordConfirm === password ? 'success' : passwordConfirm.length > 0 && 'error'

  return (
    <div>
    <Wrapper bg={Background}></Wrapper>
      <LoginWrapper>
        <LoginBox>
        <H4 color={color.paleGrey}>Change password</H4>
        <InputWithLabel
          width='70%'
          input={{
            prefix: <Icon className='prefix' icon='far fa-key' />,
            type: 'password',
            color: color.coolGrey,
            onChange: e => setPassword(e.target.value),
          }}
          title={{
            text: 'New Password',
            color: color.paleGrey,
          }}
          margin='16px 0 16px 0'
        />
        <InputWithLabel
          width='70%'
          input={{
            prefix: <Icon className='prefix' icon='far fa-key' />,
            type: 'password',
            color: color.coolGrey,
            onChange: e => setPasswordConfirm(e.target.value),
          }}
          title={{
            text: 'Confirm New Password',
            color: color.paleGrey,
          }}
          margin='0 0 16px 0'
        />
        <Div display='flex' width='70%'>
          <Label color={color.paleGrey} margin='0 0 16px 0'>Please set password length to be at least 8 characters</Label>
        </Div>
        <Mutation
          mutation={RESET_PASSWORD}
        >
        {(doResetpassword, { loading }) => (
          <Button
            ghost
            inverse
            text='Change Password'
            disabled={!isEveryIndex([validatePassword, validateConfirmPassword], 'success')}
            loading={loading}
            onClick={() => doResetpassword({
              variables: {
                token: props.match.params.token,
                password,
              },
            }).then((resp) => {
              if (!resp.loading && resp.data.resetPassword.success) {
                message.success(resp.data.resetPassword.message)
                setTimeout(() => {
                  history.push('/login')
                }, 3000)
                // history.push('/')
              } else message.error(resp.data.resetPassword.message)
            })}
          />
        )}
        </Mutation>
        </LoginBox>
      </LoginWrapper>
    </div>
  )
}
export { ForgotPasswordSection, ResetSection }



// WEBPACK FOOTER //
// ./src/pages/login/reset-password.jsx